<template>
    <div>
        <dx-grid
            :url="url"
            name="hs-students-view"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :selectionEnabled="true"
            :expandedOptions="{
                enabled: true,
                template: 'hs-students-change-logs',
            }"
        ></dx-grid>

        <v-dialog v-model="updateDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update Student</v-card-title
                >

                <div class="px-2 mt-2">
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child First
                        </div>
                        <div>{{ clickedRow.childFirst }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Child Last
                        </div>
                        <div>{{ clickedRow.childLast }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Father</div>
                        <div>{{ clickedRow.father }}</div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">Address</div>
                        <div>
                            {{
                                clickedRow.address1 +
                                    " " +
                                    (clickedRow.address2
                                        ? clickedRow.address2
                                        : "")
                            }}
                        </div>
                    </v-layout>
                    <v-layout row class="mb-2">
                        <div class="font-weight-medium width-150">
                            Primary Phone
                        </div>
                        <div>{{ clickedRow.familyPrimaryPhone }}</div>
                    </v-layout>
                    <v-divider class="my-2 pb-2"></v-divider>
                    <v-select
                        v-model="clickedRow.hsFlag"
                        :items="hsFlagList"
                        label="HS Flag"
                        clearable
                        hide-details
                        class="mb-3"
                    ></v-select>
                    <v-text-field
                        v-model="clickedRow.hsNote"
                        label="HS Note"
                        hide-details
                        class="mb-3"
                    ></v-text-field>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="updateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="save"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="hsFlagUpdaterDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update HS Flag</v-card-title
                >
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{
                                    student.childFirst + " " + student.childLast
                                }}
                            </div>
                            <div class="caption">
                                Father: {{ student.father }}
                            </div>
                            <div class="caption">
                                {{
                                    student.address1 +
                                        " " +
                                        (student.address2
                                            ? student.address2
                                            : "")
                                }}
                            </div>
                            <div class="body-2">
                                {{ student.familyPrimaryPhone }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-select
                        v-model="hsFlag"
                        label="HS Flag"
                        clearable
                        outline
                        hide-details
                        class="mb-3 mt-2"
                        :items="hsFlagList"
                    ></v-select>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="hsFlagUpdaterDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveHsFlag"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="hsNoteUpdaterDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2"
                    >Update HS Note</v-card-title
                >
                <div class="px-2 mt-2">
                    <div style="overflow-y: auto; height: 300px">
                        <div v-for="(student, index) in selected">
                            <div class="font-weight-medium">
                                {{
                                    student.childFirst + " " + student.childLast
                                }}
                            </div>
                            <div class="caption">
                                Father: {{ student.father }}
                            </div>
                            <div class="caption">
                                {{
                                    student.address1 +
                                        " " +
                                        (student.address2
                                            ? student.address2
                                            : "")
                                }}
                            </div>
                            <div class="body-2">
                                {{ student.familyPrimaryPhone }}
                            </div>
                            <v-divider
                                class="my-2"
                                v-if="index + 1 < selected.length"
                            ></v-divider>
                        </div>
                    </div>
                    <v-text-field
                        v-model="hsNote"
                        label="HS Note"
                        outline
                        hide-details
                        class="mb-3 mt-2"
                    ></v-text-field>
                </div>
                <v-card-actions class="pt-3 mr-2 mt-3 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="hsNoteUpdaterDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveHsNote"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { loadOptions } from "../../utils/smLookup.js";

export default {
    data: () => ({
        title: "HS Students View",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        updateDialog: false,
        clickedRow: {},
        processing: false,

        hsFlagUpdaterDialog: false,
        hsNoteUpdaterDialog: false,
        selected: [],
        hsNote: "",
        hsFlag: "",
        hsFlagList: [],

        pagination: {
            totalCount: 0,
            rowsPerPage: 13,
            page: 1,
        },

        columns: [
            {
                label: "Screening Date",
                field: "screeningDate",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Child First",
                field: "childFirst",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Child Last",
                field: "childLast",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Birthday",
                field: "birthday",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address 1",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address 2",
                field: "address2",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Primary Phone",
                field: "familyPrimaryPhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father",
                field: "father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Mother",
                field: "mother",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Child Plus Family ID",
                field: "familyID",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "UTA Flag",
                field: "utaFlag",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "HS Flag",
                field: "hsFlag",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Priority",
                field: "priority",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "donorID",
                label: "Ansl ID",
                link: "DinnerAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Name",
                field: "anslName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Hebrew",
                field: "lastHebrew",
                format: "",
                sortOrder: "asc",
                sortIndex: 0,
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Hebrew",
                field: "firstHebrew",
                sortOrder: "asc",
                sortIndex: 1,
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Father",
                field: "anslFather",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Ansl Father In Law",
                field: "anslFatherInLaw",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "utaAccountID",
                label: "UTA Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "HS Note",
                field: "hsNote",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;
        this.columns.find((c) => c.field == "donorID").showLink = this.showLink;

        this.loadHsFlags();
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "Update HS Flag",
                action: this.openHsFlagUpdater,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Update HS Note",
                action: this.openHsNoteUpdater,
                showOnSelection: true,
            });

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url =
                "hsStudents?onlyHs=true&onlyVoucher=" + "&regID=" + this.regID;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/hsStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/hsStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "hsStudents?onlyHs=true&onlyVoucher=" + "&regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadHsFlags() {
            this.hsFlagList = (await loadOptions("HSFlag")).map((c) => c.value);
        },
        showLink() {
            return (
                !this.$store.state.authentication.branch ||
                this.$store.state.authentication.branch == "null"
            );
        },
        openHsFlagUpdater() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.hsFlagUpdaterDialog = true;
        },
        openHsNoteUpdater() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.hsNoteUpdaterDialog = true;
        },
        async onRowClicked(row) {
            this.clickedRow = JSON.parse(JSON.stringify(row));

            this.updateDialog = true;
        },
        async save() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/hsStudents/updateFlag",
                    this.clickedRow,
                );

                this.processing = false;
                this.updateDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveHsFlag() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            // if (!this.hsFlag) {
            //     return this.$notify({
            //         text: "Missing HS Flag",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/hsStudents/UpdateHSFlag",
                    this.selected.map((s) => {
                        s.hsFlag = this.hsFlag;

                        return s;
                    }),
                );

                this.processing = false;
                this.hsFlagUpdaterDialog = false;
                this.hsFlag = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveHsNote() {
            if (!this.selected.length) {
                return this.$notify({
                    text: "No Students Selected",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post(
                    "api/hsStudents/updateHsNote",
                    this.selected.map((s) => {
                        s.hsNote = this.hsNote;

                        return s;
                    }),
                );

                this.processing = false;
                this.hsNoteUpdaterDialog = false;
                this.hsNote = "";

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.hs-selected-match {
    border: 2px solid red;
}
.hs-match {
    border: 1px solid #4caf50;
}
.accounts-search.container {
    padding-top: 0px;
}
</style>
